import { createFileRoute } from "@tanstack/react-router";
import StripeSuccess from "@/pages/StripeSuccess";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/success/")({
  head: () => routeHead("/success/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <StripeSuccess />
  );
}
